module.exports = __webpack_public_path__ + "img/b_log_stop.ef50012e.png";